import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import { AbilityRangeGenerator } from '../../../../utils/AssessmentUtil';
import { intlShape } from '../../../../components/prop-types';

const i18nMessages = defineMessages({
  assessmentTopInterests: {
    id: 'assessment.topInterests',
    defaultMessage: 'Top Interests for',
  },
});

class Interest extends Component {
  render() {
    const {
      interest, intl, respondent, jobProfile,
    } = this.props;
    if (!interest) {
      return <div />;
    }
    const matchResult = interest.dimensionMatchResults;

    if (!matchResult) {
      return <div />;
    }

    const panelHeader = (
      <div className="panel-header">
        <span className={`pull-right label ${AbilityRangeGenerator.mapOverallLabelToPercent(interest.matchPercent)}`}>
          {`${interest.matchPercent} %`}
        </span>
        <span>{interest.displayName}</span>
      </div>
    );
    const respondentInterests = AbilityRangeGenerator.generateInterestListForRespondent(matchResult);
    const jobProfileInterests = AbilityRangeGenerator.generateInterestListForJobProfile(matchResult);

    const interestGroup = (subject, groupResults) => (
      <div className="interestGroup">
        <div className="interestGroup-title">
          <span>
            {intl.formatMessage(i18nMessages.assessmentTopInterests)}
            <strong>
              {` ${subject}`}
            </strong>
          </span>
        </div>
        <div className="interestGroup-body">
          {groupResults}
        </div>
      </div>
    );


    return (
      <div className="ability">
        {matchResult.length > 0 && panelHeader}
        <div className="panel-body abilityContainer">
          {matchResult.length > 0 && interestGroup(`${respondent.firstName} ${respondent.lastName}`,
            respondentInterests)}
          {matchResult.length > 0 && interestGroup(`${jobProfile.name}`, jobProfileInterests)}
        </div>
      </div>
    );
  }
}

Interest.propTypes = {
  jobProfile: PropTypes.objectOf(PropTypes.any).isRequired,
  respondent: PropTypes.objectOf(PropTypes.any).isRequired,
  interest: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(Interest);
